<template>
  <div class="loader-back" unselectable="on">
    <table class="main-table">
      <tr>
        <td class="td-logo" width="30%"><img src="/imgs/logo_impay.png"></td>
        <td width="40%" align="center"></td>
        <td width="30%"></td>
      </tr>
      <tr>
        <td colspan="3" align="center">
          <div class="info-message">Автоматический выход через {{timeLeft}} секунд</div>
        </td>
      </tr>
      <tr>
        <td class="td-nav" width="30%">
        </td>
        <td class="td-nav" width="40%" align="center">
          <img @click="exitClick" src="/imgs/menu_exit_1.png">
        </td>
        <td class="td-nav" width="30%" align="right">
          <img @click="backClick" src="/imgs/continue_1.png">
        </td>
      </tr>
    </table>
  </div>
</template>


<script>
export default {
  name: "SessionTimeout",
  props: {
    visible: Boolean,
    onClose: Function,
  },
  data() {
    return {
      timer: null,
      timeLeft: 30
    }
  },
  mounted() {
  },
  methods: {
    backClick() {
      this.stopTimer()
      this.onClose(true)
    },
    exitClick() {
      this.stopTimer()
      this.onClose(false)
    },
    startTimer() {
      this.stopTimer()

      this.timeLeft = 30

      this.timer = setInterval(() => {
        if (this.timeLeft > 1) {
          this.timeLeft--;
        } else {
          this.stopTimer()
          this.onClose(false)
        }
      }, 1000);
    },
    stopTimer() {
      if (this.timer !== null) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.startTimer()
      } else {
        this.stopTimer()
      }
    }
  }
}
</script>

<style scoped>

.loader-back {
  position: fixed;
  top: 0;
  left: 0;
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  z-index: 9999;
  background-color: #F5F5F5;
  padding: 20px;
}

.info-message {
  font-size: 36px;
  word-wrap: anywhere;
}
</style>
